import styled from 'styled-components'

export const ContentImg = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: 242px;
    margin-top: 32px;
`
export const ContainerImg = styled.span`
    padding: 8px;
    background-color: #1e4fff;
    height: 52px;
    border-radius: 8px;
    width: 101px;
    padding: 14px;

    display: flex;
    align-items: center;
    justify-content: center;

    > img {
        height: auto;
        width: 100%;
    }
`
